import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
export function Bonuses() {
  return <section className="bg-cream py-16 md:py-24" data-id="element-95" data-mp="1clpjan0xo2ti">
      <div className="mx-auto max-w-4xl px-5" data-id="element-96" data-mp="18julvtm4i9l0">
        <SectionHeading eyebrow="Included free today" title={<>
              5 Exclusive <em className="italic text-gold-dark" data-id="element-98" data-mp="257r4t5519gze">Bonuses</em>
            </>} intro="Worth $197 on their own — yours at no extra cost when you get the Master System today." data-id="element-97" data-mp="18l5pntfkjhc4" />
      </div>

      <div className="mx-auto mt-10 max-w-4xl space-y-8 md:px-5" data-id="element-99" data-mp="1wb01c7o5izus">
        {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white md:rounded-3xl md:border md:border-navy/10" data-id="element-100" data-mp="1rcewtw1v9u0j">
            <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" data-id="element-101" data-mp="fv6v5iilus02" />
            <div className="px-5 pb-7 pt-2 md:px-8 md:pb-8" data-id="element-102" data-mp="1etwqp1ta00e8">
              <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-103" data-mp="1eug8miixeos9">
                <span className="flex items-center gap-1.5 rounded-full bg-navy px-3 py-1 text-xs font-black uppercase tracking-widest text-gold" data-id="element-104" data-mp="1jrgdiq41hlhs">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-105" data-mp="1as1q5zj65r1i" />
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-bold text-navy/60" data-id="element-106" data-mp="w2xb2r7o82xm">
                  Value: <s data-id="element-107" data-mp="10tm0m0zsipu4">{b.value}</s> — <span className="font-black text-cta" data-id="element-108" data-mp="10u5hrfhm9a73">FREE</span>
                </span>
              </div>
              <h3 className="mt-4 font-serif text-2xl font-black leading-tight text-navy md:text-3xl" data-id="element-109" data-mp="n3ijtpjojoc2">{b.title}</h3>
              <p className="mt-3 text-[16px] leading-relaxed text-navy/75" data-id="element-110" data-mp="r4vnbszavfft">{b.body}</p>
              {b.listLabel && <p className="mt-3 text-[16px] font-semibold text-navy" data-id="element-111" data-mp="d4tcurtbnoal">{b.listLabel}</p>}
              {b.items && <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-112" data-mp="i5gzz2efjkzj">
                  {b.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-navy" data-id="element-113" data-mp="2jueju5gdtpqp">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-114" data-mp="2ezquk4dk0rb2" />
                      {item}
                    </li>)}
                </ul>}
              <p className="mt-5 rounded-xl bg-gold-soft px-4 py-3 text-center font-serif text-lg font-bold italic text-navy" data-id="element-115" data-mp="25zc4ystk4q1r">
                {b.tagline}
              </p>
            </div>
          </article>)}
      </div>

      <div className="px-5" data-id="element-116" data-mp="2tq812251q7et">
        <SectionCta label="I want all 5 bonuses free" data-id="element-117" data-mp="2tpgax6u7x1vx" />
      </div>
    </section>;
}